import Layout from './layout';
export default Layout;


// WEBPACK FOOTER //
// ./src/components/layout/index.js